function loadTooltip() {
    setTimeout(() => {
        let $dataToggleTooltip = $('[data-toggle="tooltip"]');
        if($dataToggleTooltip.length) {
            $dataToggleTooltip.tooltip();
        }
    }, 300);
}
$(function () {
    loadTooltip();
});
